import React, { useState } from 'react';
import styles from "./VehicleView.module.css";
import InfoLineView, { InfoLine } from '../../Components/InfoLineView';
import { VehicleDTO } from '../../Networking/Interface/Account/AccountInterface';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';

type VehicleViewProps = {
    vehicles: VehicleDTO[];
}

function formatDistance(meters: number): string {
    const km = meters / 1000;
    if (km >= 1_000) return `${(km / 1_000).toFixed(1)}k km`;
    if (km >= 1) return `${km.toFixed(1)} km`;
    return `${meters} m`;
}

const VehicleCard: React.FC<{ vehicle: VehicleDTO }> = ({ vehicle }) => {
    const [expanded, setExpanded] = useState(false);
    const healthPct = vehicle.vehicleMaxHealth > 0
        ? (vehicle.vehicleHealth / vehicle.vehicleMaxHealth) * 100
        : 0;

    return (
        <div className={styles.vehicleCard}>
            <div className={styles.cardBody}>
                <div className={styles.imageWrap}>
                    <img
                        src={`${process.env.PUBLIC_URL}/samp/vehicles/${vehicle.model}.png`}
                        alt="Vehicle"
                        className={styles.vehicleImage}
                    />
                </div>
                <div className={styles.vehicleInfo}>
                    <div className={styles.titleRow}>
                        <h3 className={styles.plate}>{vehicle.numberplate || `Vehicle`}</h3>
                        <span className={styles.dbId}>#{vehicle.dbId}</span>
                    </div>
                    <div className={styles.vehicleHealth}>
                        <div className={styles.healthBar} style={{ width: `${healthPct}%` }} />
                    </div>
                    <div className={styles.summaryRow}>
                        <span>Model {vehicle.model}</span>
                        <span className={styles.dot}>·</span>
                        <span>{formatDistance(vehicle.distance)}</span>
                        <span className={styles.dot}>·</span>
                        <span>{vehicle.vehicleFuel}L fuel</span>
                    </div>
                    <button
                        className={styles.toggleBtn}
                        onClick={() => setExpanded(prev => !prev)}
                    >
                        {expanded ? <MdExpandLess size={16} /> : <MdExpandMore size={16} />}
                        {expanded ? "Hide details" : "Show details"}
                    </button>
                </div>
            </div>

            {expanded && (
                <div className={styles.detailsPane}>
                    <InfoLineView title="Details">
                        <InfoLine label="Model" value={vehicle.model} />
                        <InfoLine label="Colors" value={`${vehicle.color1} / ${vehicle.color2}`} />
                        <InfoLine label="Fuel" value={`${vehicle.vehicleFuel}L`} />
                        <InfoLine label="Distance" value={formatDistance(vehicle.distance)} />
                        {!!vehicle.tax && <InfoLine label="Tax" value={vehicle.tax} />}
                        {!!vehicle.lastTaxDate && <InfoLine label="Last Tax Date" value={vehicle.lastTaxDate} />}
                        {!!vehicle.locked && <InfoLine label="Locked" value={vehicle.locked} />}
                        <InfoLine label="Transferrable?" value={vehicle.transferrable ? "Yes" : "No"} />
                    </InfoLineView>
                </div>
            )}
        </div>
    );
};

const VehicleView: React.FC<VehicleViewProps> = ({ vehicles }) => {
    return (
        <div className={styles.vehicleList}>
            {vehicles.map(vehicle => (
                <VehicleCard key={vehicle.dbId} vehicle={vehicle} />
            ))}
        </div>
    );
}

export default VehicleView;
